'use strict';

exports.__esModule = true;

var _AccessibleFakeButton = require('./AccessibleFakeButton');

var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);

var _injectInk = require('../Inks/injectInk');

var _injectInk2 = _interopRequireDefault(_injectInk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Helpers/AccessibleFakeInkedButton.js
// module id = 24
// module chunks = 79611799117203 213534597649335